var dev = process.env.NODE_ENV !== 'production';
const devApiBaseUrl = 'https://localhost:44396';

const configuration = {
    reCaptchaSiteKey: '6Ldp7WMUAAAAADole0XLoeHU3daXYMzwvD5W3ec3',
    role: {
        admin: '1',
        dealer: '3',
        inspector: '4',
        operator: '5'
    },
    authType: {
        cert: {
            id: 101,
            name: 'CERTIFICATE'
        },
        certNca: {
            id: 102,
            name: 'CERTIFICATE_NCA'
        },
        pass: {
            id: 100,
            name: 'PASSWORD'
        }
    }
}

function getUrls(baseUrl) {
    return {
        baseUrl: baseUrl,
        account: {
            check: `${baseUrl}/api/auth/user/type`,
            login: `${baseUrl}/api/auth/user/login`,
            getSms: `${baseUrl}/api/auth/user/sms/get`,
            verifySms: `${baseUrl}/api/auth/user/sms/verify`,
            verifySmsNca: `${baseUrl}/api/auth/user/sms/verify/nca`,
            info: `${baseUrl}/api/auth/user/info`
        },
        person: {
            getAll: `${baseUrl}/api/admin/users`,
            create: `${baseUrl}/api/admin/user/create`,
            update: `${baseUrl}/api/admin/user/update`,
            revokeCert: `${baseUrl}/api/admin/user/certificate/revoke`,
            setDealer: `${baseUrl}/api/admin/user/link/dealer`,
            changePass: `${baseUrl}/api/settings/user/password/change`
        },
        dealer: {
            getAll: `${baseUrl}/api/admin/dealers`,
            create: `${baseUrl}/api/admin/dealer/create`,
            update: `${baseUrl}/api/admin/dealer/update`
        },
        report: {
            getAll: `${baseUrl}/api/report/all`,
            get: `${baseUrl}/api/report/get`,
            createX: `${baseUrl}/api/report/x/create`,
            createPeriod: `${baseUrl}/api/report/period/create`,
            createCashier: `${baseUrl}/api/report/cashier/create`,
            createSection: `${baseUrl}/api/report/section/create`,
            viewLog: `${baseUrl}/api/report/log`,
            getFile: `${baseUrl}/api/report/get/file`
        },
        kkm: {
            getAll: `${baseUrl}/api/admin/kkms`,
            create: `${baseUrl}/api/admin/kkm/create`,
            update: `${baseUrl}/api/admin/kkm/edit`,
            setCashier: `${baseUrl}/api/admin/kkm/cashier/set`,
            setOfdData: `${baseUrl}/api/kkm/ofd/data/set`,
            setOfdWork: `${baseUrl}/api/admin/ofd/work/set`,
            startFiscal: `${baseUrl}/api/admin/kkm/fiscal/start`,
            stopFiscal: `${baseUrl}/api/admin/kkm/fiscal/stop`,
            setPoint: `${baseUrl}/api/admin/kkm/point/set`,
            setBlockStatus: `${baseUrl}/api/admin/kkm/block/status`,
            blocked: `${baseUrl}/api/kkm/get/blocked`,
            setProgramMode: `${baseUrl}/api/admin/kkm/mode/program`,
            setWorkMode: `${baseUrl}/api/admin/kkm/mode/work`,
            canChangePublicKey: `${baseUrl}/api/admin/kkm/key/public/change`,
            close: `${baseUrl}/api/ccm/close`
        },
        ticket: {
            get: `${baseUrl}/api/tickets/get`,
            getById: `${baseUrl}/api/tickets/id`,
            sellReturn: `${baseUrl}/api/tickets/sell/return`
        },
        task: {
            getTasks: `${baseUrl}/api/tasks`,
            getTaskTypes: `${baseUrl}/api/tasks/types`
        },
        moneyPlacement: {
            get: `${baseUrl}/api/moneyPlacement/get`,
            create: `${baseUrl}/api/moneyPlacement/tasks`
        },
        taxOrgs: `${baseUrl}/api/admin/taxorgs`,
        info: {
            city: `${baseUrl}/api/info/address/city`,
            street: `${baseUrl}/api/info/address/street`,
            home: `${baseUrl}/api/info/address/home`,
            point: `${baseUrl}/api/admin/address/point`,
            house: `${baseUrl}/api/admin/address/point/house`,
            createAddress: `${baseUrl}/api/admin/address/point/create`,
            updateAddress: `${baseUrl}/api/admin/address/point/update`
        },
        audit: {
            get: `${baseUrl}/api/admin/audit/security`
        },
        systemAttribute: {
            get: `${baseUrl}/api/admin/sys/attributes`,
            set: `${baseUrl}/api/admin/sys/attributes/set`
        },
        attributes: {
            getSysAttributes: `${baseUrl}/api/admin/sys/attributes`,
            updateSysAttribute: `${baseUrl}/api/admin/sys/attributes/set`
        },
        versions: {
            server: `${baseUrl}/api/versions/server`
        }
    }
}

const config = {
    ...configuration,
    apiUrls: getUrls(dev ? devApiBaseUrl : '')
};

const def = {
    install: Vue => {
        Vue.prototype.$appConfig = config
    }
}
export { def as default, config }
